/* Mirror cart store (10/1/26). The Alpine `cart` store used to live only inside the compiled bundle.js (Weberous
   build; source on a private GitLab). bundle.js now registers `window.cgCartStore` when it exists, so the cart logic
   is this hand-maintained file. Same public shape as before (isOpen, loading, itemCount, cartHtml, cartAjaxHtml,
   cartTotal, cartTotalPrice, open/close/toggle, add/change/changeById/update/reload) plus `error`.
   What changed: one round trip per action (the Ajax API returns the re-rendered sections with the change — no
   second GET); lines are addressed by line_item.key through /cart/change.js (update.js keyed on variant id merged
   two lines of the same variant with different properties); errors show inside the drawer instead of alert();
   a stale response (a slower earlier request landing after a later one) is ignored. */
(function () {
  var SECTIONS = 'section-ajax-cart,main-cart';
  var seq = 0;
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error(j.description || j.message || ('Cart error ' + r.status)); e.data = j; e.status = r.status; throw e; }
          return j;
        });
      });
  }
  function q(doc, sel) { return doc ? doc.querySelector(sel) : null; }
  window.cgCartStore = {
    isOpen: false, loading: false, itemCount: 0, cartHtml: '', cartAjaxHtml: '', cartTotal: 0, cartTotalPrice: '', error: '',
    init: function () {
      var s = this;
      this.reload();
      if (window.location.hash.indexOf('open-cart') >= 0) setTimeout(function () { s.open(); window.location.hash = ''; }, 500);
    },
    open: function (reload) { this.isOpen = true; this.error = ''; if (reload) this.reload(); document.body.classList.add('overflow-hidden'); },
    close: function () { this.isOpen = false; document.body.classList.remove('overflow-hidden'); },
    toggle: function () { if (this.isOpen) this.close(); else this.open(); },
    _run: function (url, body, toast) {
      var s = this, my = ++seq;
      s.loading = true; s.error = '';
      body.sections = SECTIONS;
      return post(url, body).then(function (j) {
        if (my !== seq) return;
        if (j && j.sections) s.renderFromHtmlString(j.sections); else s.reload();
        if (toast && window.Toastify) window.Toastify(toast, 3000);
      }).catch(function (e) { if (my === seq) s.handleError(e); });
    },
    changeById: function (id, quantity) { return this._run('/cart/change.js', { id: id, quantity: quantity }, Number(quantity) === 0 ? 'Removed' : 'Changed'); },
    change: function (line, quantity) { return this._run('/cart/change.js', { line: line, quantity: quantity }, Number(quantity) === 0 ? 'Removed' : 'Changed'); },
    update: function (id, quantity) {
      /* a line key (has a ':') goes through change.js; a bare variant id keeps the old update.js path for older call sites */
      if (typeof id === 'string' && id.indexOf(':') >= 0) return this.changeById(id, quantity);
      var u = {}; u[id] = quantity;
      return this._run('/cart/update.js', { updates: u }, 'Updated');
    },
    add: function (items) { this.open(false); return this._run('/cart/add.js', { items: items || [] }, 'Added'); },
    renderProgressShippingBar: function (doc) {
      var cartEl = q(doc, '#cartStringJSON'), freeEl = q(doc, '#freeShippingStringJSON'), bar = q(document, '[data-cart-shipping-progress]');
      if (!cartEl || !freeEl || !bar) return;
      try {
        var total = JSON.parse(cartEl.textContent).total_price / 100, free = Number(JSON.parse(freeEl.textContent)) || 0;
        var pct = free > 0 ? Math.min(100, total / free * 100) : 100;
        bar.style.width = pct + '%';
        bar.style.backgroundColor = pct >= 100 ? '#19B68B' : '#ED2326';
      } catch (e) {}
    },
    renderFromHtmlString: function (sections) {
      var parser = new DOMParser();
      if (sections['section-ajax-cart'] != null) {
        var a = parser.parseFromString(sections['section-ajax-cart'], 'text/html');
        var body = q(a, '#shopify-section-section-ajax-cart [data-cart-body]');
        if (body) {
          var h = body.innerHTML;
          /* identical HTML (cart unchanged after a refused change) would not re-render through x-html — nudge it so the line's quantity resets */
          if (h === this.cartAjaxHtml) h += '<!--r' + Date.now() + '-->';
          this.cartAjaxHtml = h;
        }
        var cnt = q(a, '#shopify-section-section-ajax-cart [data-items-count]');
        if (cnt) {
          var n = Number(cnt.dataset.itemsCount) || 0;
          this.itemCount = n > 9 ? '9+' : n;
          var live = q(document, '#shopify-section-section-ajax-cart [data-items-count]');
          if (live) live.dataset.itemsCount = cnt.dataset.itemsCount;
        }
        var tot = q(a, '#shopify-section-section-ajax-cart [data-cart-total]'), totLive = q(document, '#shopify-section-section-ajax-cart [data-cart-total]');
        if (tot && totLive) { totLive.dataset.cartTotal = tot.dataset.cartTotal; this.cartTotal = Number(tot.dataset.cartTotal) || 0; }
        var tp = q(a, '#shopify-section-section-ajax-cart [data-cart-total-price]'), tpLive = q(document, '#shopify-section-section-ajax-cart [data-cart-total-price]');
        if (tp && tpLive) { tpLive.dataset.cartTotalPrice = tp.dataset.cartTotalPrice; this.cartTotalPrice = tp.dataset.cartTotalPrice; }
        this.renderProgressShippingBar(a);
        var express = q(document, '.additional_checkout_buttons');
        if (express) express.classList.toggle('hidden', !(Number(cnt && cnt.dataset.itemsCount) > 0));
      }
      if (sections['main-cart'] != null && window.Shopify && window.Shopify.routes && window.location.pathname === window.Shopify.routes.cartUrl) {
        var m = parser.parseFromString(sections['main-cart'], 'text/html');
        var mb = q(m, '#shopify-section-main-cart [data-cart-body]');
        if (mb) this.cartHtml = mb.innerHTML;
      }
      this.loading = false;
    },
    renderFromResponse: function () { this.reload(); },
    handleError: function (e) {
      this.loading = false;
      var msg = (e && e.data && (e.data.description || e.data.message)) || (e && e.message) || 'Something went wrong. Please try again.';
      this.error = msg;
      if (!this.isOpen && window.Toastify) window.Toastify(msg, 4000);
      /* a refused change (e.g. "Only 1 item was added … due to availability") leaves the drawer's quantity ahead of the real cart — resync */
      if (e && e.status) this.reload();
    },
    reload: function () {
      var s = this, my = ++seq;
      s.loading = true;
      return fetch('/?sections=' + SECTIONS, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (my === seq) s.renderFromHtmlString(j); })
        .catch(function (e) { if (my === seq) s.handleError(e); });
    }
  };
})();
